import { startOfDay } from "date-fns";

export const isQuarterHour = (date?: Date) =>
  [0, 15, 30, 45].includes(date?.getMinutes() || 0);

export const timesAreSuccessive = (
  timeOne: Date,
  timeTwo: Date,
  dateOne?: Date,
  dateTwo?: Date,
): boolean =>
  timeOne.getHours() < timeTwo.getHours() ||
  (timeOne.getHours() === timeTwo.getHours() &&
    timeOne.getMinutes() < timeTwo.getMinutes()) ||
  (dateOne && dateTwo ? startOfDay(dateOne) < startOfDay(dateTwo) : false);
